// @ts-strict-ignore
import { Component } from "@angular/core";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import * as ProfileModel from "src/app/shared/models/profile.model";

@Component({
  selector: C.EWIZ_REGULATORY_ECALL_SUPPORT_CONFIGURATION,
  templateUrl: "./regulatory-ecall-support-configuration.component.html",
  standalone: false
})
export class EWizRegulatoryECallSupportConfigurationComponent extends EWizDynamicBaseClassComponent implements ProgressCheck {
  progressCheck(values: ProfileModel.ProfileDto) {
    if (values.regulatoryECallSupport) {
      if (values.regulatoryECallSupport.supportECall === null) {
        return false;
      } else if (+values.regulatoryECallSupport.supportECall === 1 && values.regulatoryECallSupport.eCallType === null) {
        return false;
      }
    } else {
      return false;
    }

    return true;
  }

  updateRegulatorySupport() {
    if (+this.profileValues.regulatoryECallSupport?.supportECall === 1) {
      this.profileValues.usimServiceTable.usimService34 = true;

      if (+this.profileValues.regulatoryECallSupport?.eCallType === 1) {
        this.profileValues.usimServiceTable.usimService2 = true;
        this.profileValues.usimServiceTable.usimService4 = false;
        this.profileValues.usimServiceTable.usimService89 = true;
      } else if (+this.profileValues.regulatoryECallSupport?.eCallType === 2) {
        this.profileValues.usimServiceTable.usimService2 = false;
        this.profileValues.usimServiceTable.usimService4 = true;
        this.profileValues.usimServiceTable.usimService89 = true;
      }
    } else if (+this.profileValues.regulatoryECallSupport?.supportECall === 0) {
      this.profileValues.usimServiceTable.usimService2 = false;
      this.profileValues.usimServiceTable.usimService4 = false;
      this.profileValues.usimServiceTable.usimService34 = false;
      this.profileValues.usimServiceTable.usimService89 = false;
      this.profileValues.usimServiceTable.usimService112 = false;
    }

    this.handleFormEvents();
  }
}
